import HeatmapActionTypes from "../../constants/Applications/heatMap-actionTypes";

const initialState = {
    heatmapTableData: [],
    heatmapDropdownData: [],
    heatmapFormTableData: [],
    vishingDropdownData: [],
    vishingFormTableData: [],
    vishingValidateTicketNo:[]
};

const heatmapReducer = (state = initialState, action) => {
    switch (action.type) {
        case HeatmapActionTypes.GET_HEATMAP_TABLE_DATA:
        case HeatmapActionTypes.GET_HEATMAP_DROPDOWN_DATA:
        case HeatmapActionTypes.GET_HEATMAP_FORM_TABLE_DATA:
        case HeatmapActionTypes.GET_VISHING_DROPDOWN_DATA:
        case HeatmapActionTypes.GET_VISHING_FORM_TABLE_DATA:
        case HeatmapActionTypes.GET_VISHING_VALIDATE_TICKET_NO:



            return { ...state };
        case HeatmapActionTypes.HEATMAP_TABLE_DATA:
          return { ...state, heatmapTableData: action.payload };
        case HeatmapActionTypes.HEATMAP_DROPDOWN_DATA:
          return { ...state, heatmapDropdownData: action.payload };
        case HeatmapActionTypes.HEATMAP_FORM_TABLE_DATA:
          return { ...state, heatmapFormTableData: action.payload };
        case HeatmapActionTypes.VISHING_DROPDOWN_DATA:
          return { ...state, vishingDropdownData: action.payload };
        case HeatmapActionTypes.VISHING_FORM_TABLE_DATA:
          return { ...state, vishingFormTableData: action.payload };
        case HeatmapActionTypes.VISHING_VALIDATE_TICKET_NO:
          return { ...state, vishingValidateTicketNo: action.payload };
        default:
            return state;
    }
};

export default heatmapReducer;
